import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-notification-suppression-devis',
  templateUrl: './notification-suppression-devis.component.html',
  styleUrls: ['./notification-suppression-devis.component.scss'],
})
export class NotificationSuppressionDevisComponent implements OnInit {
  details;
  constructor(private navParams: NavParams, private modalController: ModalController) {
this.details = this.navParams.get('details')
  }

  ngOnInit() { }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    return this.modalController.dismiss({
      'dismissed': true
    });
  }

  deleteDevis() {
    return this.modalController.dismiss({
      'delete': true
    });
  }
}
